import React, { Ref } from 'react';
import { HTMLFieldProps, connectField, filterDOMProps } from 'uniforms';

export type LongTextFieldProps = HTMLFieldProps<
  string,
  HTMLDivElement,
  { inputRef?: Ref<HTMLTextAreaElement> }
>;

function LongText({
  disabled,
  id,
  inputRef,
  label,
  name,
  onChange,
  placeholder,
  readOnly,
  value,
  ...props
}: LongTextFieldProps) {
  return (
    <div {...filterDOMProps(props)} className="flex items-center gap-4 py-2">
      {/* {label && (
        <label htmlFor={id} className="min-w-[200px]">
          {label}
        </label>
      )} */}

      <textarea
        disabled={disabled}
        id={id}
        name={name}
        onChange={(event) => onChange(event.target.value)}
        // placeholder={placeholder}
        placeholder={label?.toString()}
        readOnly={readOnly}
        ref={inputRef}
        value={value ?? ''}
        rows={5}
        className="textarea textarea-bordered w-full rounded border border-gray-400 px-[15px] focus:outline-none"
      />
    </div>
  );
}

export default connectField<LongTextFieldProps>(LongText, { kind: 'leaf' });
